/**
 * Страницы, куда человек попадает БЕЗ сессии — и где 401 на фоновом запросе
 * является нормой, а не поводом куда-то его уводить.
 *
 * Прод 21.08.2026. Приглашённый не увидел форму «Придумайте пароль». В логе
 * nginx это выглядело так:
 *
 *   GET /accept-invite?token=…          200   ← анонимная SPA-страница
 *   GET /api/v1/seasons                 401
 *   GET /api/v1/session/season          401
 *   POST /api/v1/auth/refresh           401
 *   GET /api/v1/accept-invite?token=…   499   ← навигацию оборвал сам фронт
 *   GET /login                          200
 *
 * `SeasonProvider` стоит над всем роутером, поэтому его запросы уходят и с
 * анонимных страниц. Они честно получили 401, `api.ts` сделал
 * `window.location.href = '/login'` — и обогнал уже начатую навигацию на
 * бэкенд-ручку приглашения. Бэкенд к тому моменту закоммитил: токен сгорел,
 * cookies не доехали. Гонка недетерминированная, потому флоу и «работал».
 *
 * Один список на оба лечения: фоновые запросы на этих страницах не стартуют
 * вовсе, а если 401 всё же пришёл — никуда не уводим. Человек остаётся там,
 * куда пришёл по ссылке из письма.
 */
export const PUBLIC_PATHS = [
  '/login',
  '/accept-invite',
  '/auth/error',
  '/auth/link-sent',
  '/auth/forgot-password',
  '/auth/reset-password',
] as const;

/**
 * `startsWith` по сегменту, а не по строке: `/loginsomething` публичным быть
 * не должен, а `/auth/reset-password?token=…` и `/accept-invite/` — должны.
 */
export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}
